<h2 mat-dialog-title>Karta płatnicza</h2>
<mat-dialog-content>
    <div class="card-details">
        <div>
            <div class="label">Numer karty</div>
            <div class="value">{{data.card.mask}}</div>
        </div>
        <div>
            <div class="label">Ważna do</div>
            <div class="value">{{data.card.expireAt}}</div>
        </div>
        <div>
            <div class="label">Typ</div>
            <div class="value">{{data.card.type}}</div>
        </div>
        <div>
            <div class="label">System płatności</div>
            <div class="value payment-system">
                @if(data.card.paymentSystem == 2) {
                <svg class="stripe-logo" viewBox="0 0 60 25" aria-label="Stripe">
                    <rect width="60" height="25" rx="5" fill="#635bff"/>
                    <text x="30" y="18" text-anchor="middle" font-size="15" font-weight="bold" fill="#fff">stripe</text>
                </svg>
                } @else if(data.card.paymentSystem == 1) {
                <span>Przelewy24</span>
                } @else {
                <span>{{data.card.paymentSystem}}</span>
                }
            </div>
        </div>
    </div>
    <div class="label source-label">Źródło</div>
    <pre class="source-json">{{sourceJson}}</pre>
</mat-dialog-content>
<mat-dialog-actions>
    <button matButton mat-dialog-close>Zamknij</button>
</mat-dialog-actions>
